import React, { useEffect } from 'react';
import { Navigate, Route } from 'react-router-dom';
import { setAuthorization } from '../helpers/api_helper';
import { useDispatch } from 'react-redux';
import { useProfile } from '../Components/Hooks/UserHooks';
// eslint-disable-next-line no-unused-vars
import { logoutUser } from '../slices/auth/login/thunk';
import SessionMonitor from '../Components/Common/SessionMonitor';
import { PermissionProvider } from '../contexts/PermissionContext';

const AuthProtected = props => {
  const dispatch = useDispatch();
  const { userProfile, loading, token } = useProfile();

  useEffect(() => {
    if (userProfile && !loading && token) {
      setAuthorization(token);
    } else if (!userProfile && !loading && !token) {
      // AUTO_LOGOUT_DISABLED_START — disabled per issue #24 (multi-login support), 2026-07-17
      // dispatch(logoutUser());
      // AUTO_LOGOUT_DISABLED_END
    }
  }, [token, userProfile, loading, dispatch]);

  // Show loading while checking authentication
  if (loading) {
    return (
      <div className='d-flex justify-content-center align-items-center min-vh-100'>
        <div className='spinner-border text-primary' role='status'>
          <span className='visually-hidden'>Loading...</span>
        </div>
      </div>
    );
  }

  /*
    Navigate is un-auth access protected routes via url
    */
  if (!userProfile && !loading && !token) {
    return (
      <Navigate to={{ pathname: '/login', state: { from: props.location } }} />
    );
  }

  return (
    <PermissionProvider>
      <SessionMonitor />
      {props.children}
    </PermissionProvider>
  );
};

const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        return (
          <>
            {' '}
            <Component {...props} />{' '}
          </>
        );
      }}
    />
  );
};

export { AuthProtected, AccessRoute };
